import React from "react";
import { Container, Row, Col, Button, Form, Accordion } from "react-bootstrap";
import "./Aboutus.css"; // reuse the same theme styles
import bannerImage from "../assets/images/HomePageBanner.webp";

const Landowners = () => {
    return (
        <>
            {/* Hero Section */}
            <div className="home-container1">
                <div
                    className="banner-section"
                    style={{ backgroundImage: `url(${bannerImage})` }}
                >
                    <div className="banner-overlay"></div>
                    <div className="banner-content">
                        <h1>
                            Have a land venture ready to be showcased?
                            <br /> Let us help you bring verified buyers to your project.
                        </h1>
                        <p className="breadcrumb-text">
                            Our team of legal consultants and former Mandal Revenue Officers
                            will verify your documents. Once cleared, your venture is listed
                            on PlotsVerified—alongside trusted, litigation-free land
                            opportunities.
                        </p>
                        <div className="d-flex justify-content-center gap-3 mt-3 flex-wrap">
                            <Button variant="warning">Submit Land for Verification</Button>
                            <Button variant="light">Schedule a Call with Our Team</Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Why List Section */}
            <section className="vision-mission-cards">
                <div className="vm-card">
                    <div className="vm-icon">✔</div>
                    <h3>Legal Trust = Buyer Confidence</h3>
                    <p>
                        Every listing is backed by documentation verified by experts.
                    </p>
                </div>
                <div className="vm-card">
                    <div className="vm-icon">⚡</div>
                    <h3>Faster Sales from Serious Buyers</h3>
                    <p>Attract buyers looking for risk-free land investments.</p>
                </div>
                <div className="vm-card">
                    <div className="vm-icon">🛡</div>
                    <h3>Post-Sale Legal Coverage</h3>
                    <p>
                        We offer 1-year legal support to buyers—making your venture even
                        more compelling.
                    </p>
                </div>
                <div className="vm-card">
                    <div className="vm-icon">📢</div>
                    <h3>Better Visibility,<br/> Zero Broker Chaos</h3>
                    <p>Get direct access to buyers without brokers or listing clutter.</p>
                </div>
            </section>

            {/* Who Should List Section */}
            <section className="story-section">
                <div className="story-left">
                    <h2>
                        Who <span>Should List Their Land?</span>
                    </h2>
                    <p>
                        We work with landowners and entities who have clean,
                        well-documented land ventures and are serious about offering
                        legally safe opportunities.
                    </p>
                    <ul>
                        <li>Agricultural, converted, or residential layout land</li>
                        <li>Ventures with clear title and ownership lineage</li>
                        <li>HMDA, DTCP, or Panchayat approved layouts</li>
                        <li>Community ventures, plotted developments, or farmland investments</li>
                    </ul>
                </div>
            </section>

            {/* Process Section */}

            <section className="process-section">
                <h2 className="process-title">Our Work Process</h2>
                <div className="process-steps">
                    <div className="process-card">
                        <h3>Step 1</h3>
                        <p>Submit your land details and basic documents</p>
                    </div>
                    <div className="arrow">➔</div>
                    <div className="process-card">
                        <h3>Step 2</h3>
                        <p>Our legal and revenue team conducts due diligence</p>
                    </div>
                    <div className="arrow">➔</div>
                    <div className="process-card">
                        <h3>Step 3</h3>
                        <p>Site inspection</p>
                    </div>
                    <div className="arrow">➔</div>
                    <div className="process-card">
                        <h3>Step 4</h3>
                        <p>Approval and onboarding</p>
                    </div>
                    <div className="arrow">➔</div>
                    <div className="process-card">
                        <h3>Step 5</h3>
                        <p>High-quality images and video preferred</p>
                    </div>
                    <div className="arrow">➔</div>
                    <div className="process-card">
                        <h3>Step 6</h3>
                        <p>Venture goes live on PlotsVerified</p>
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            <section className="team-section">
                <h2 className="team-title">Success Stories</h2>
                <div className="team-member">
                    <div className="team-info">
                        <p>
                            “PlotsVerified helped us establish credibility in a crowded
                            market. Buyers were more confident and deals closed faster.”
                        </p>
                        <h4>– Shashank (Founder)</h4>
                    </div>
                </div>
            </section>


            {/* Landowner Inquiry Form */}
            <section className="story-section">
                <div className="story-left">
                    <h2>
                        Submit Your Venture <span>for Initial Review</span>
                    </h2>
                    <Form>
                        <Row>
                            <Col md={6} className="mb-3">
                                <Form.Control type="text" placeholder="Name" />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Form.Control type="text" placeholder="Contact (Phone/Email)" />
                            </Col>
                            <Col md={12} className="mb-3">
                                <Form.Control type="text" placeholder="Location of Land" />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Form.Control type="text" placeholder="Size (optional)" />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Form.Control type="text" placeholder="Type of Venture" />
                            </Col>
                            <Col md={12} className="mb-3">
                                <Form.Control type="file" />
                            </Col>
                            <Col md={12}>
                                <Button variant="warning" type="submit">
                                    Submit for Review
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </section>
            {/* FAQ Section */}
            <section className="faq-section">
                <Container>
                    <h2 className="faq-title">FAQs for Landowners</h2>
                    <Accordion defaultActiveKey="0" flush>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>1. Who can list their land on PlotsVerified?</Accordion.Header>
                            <Accordion.Body>
                                We work with individual landowners, developers, and landholding
                                companies who have clean documentation and are offering legally
                                safe land ventures—whether it's agricultural, converted,
                                residential, or a plotted layout.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>2. What types of land ventures are eligible for listing?</Accordion.Header>
                            <Accordion.Body>
                                Eligible ventures include:
                                <ul>
                                    <li>Agricultural land with clear title</li>
                                    <li>Converted/residential land with layout approvals (HMDA, DTCP, etc.)</li>
                                    <li>Gated community layouts</li>
                                    <li>Farmland ventures or weekend plot collectives</li>
                                </ul>
                                We review each submission individually and may request supporting
                                documentation.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>3. Is there a minimum land size required?</Accordion.Header>
                            <Accordion.Body>
                                There is no hard minimum, but preference is given to ventures
                                with proper documentation and a clear buyer proposition (plotted
                                layout, development plan, or grouped holdings).
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>4. How long does the verification process take?</Accordion.Header>
                            <Accordion.Body>
                                The average timeline is <b>7–15 working days</b>, depending on
                                documents, local jurisdiction, and complexity. We’ll update you
                                at each step.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>5. What documents are needed initially?</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li>Title deed or sale deed</li>
                                    <li>Layout approval (if any)</li>
                                    <li>Encumbrance Certificate (EC)</li>
                                    <li>Tax receipts or pattadar passbook</li>
                                    <li>Land location and survey details</li>
                                </ul>
                                Additional documents may be requested depending on your region.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                            <Accordion.Header>6. Do I have to pay to list my land?</Accordion.Header>
                            <Accordion.Body>
                                <b>No.</b> Listing is completely free. We only charge a success
                                fee once buyer leads generated through PlotsVerified close into
                                deals.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="6">
                            <Accordion.Header>7. How does PlotsVerified attract buyers?</Accordion.Header>
                            <Accordion.Body>
                                We market ventures across:
                                <ul>
                                    <li>Google and Meta Ads</li>
                                    <li>Real estate communities and buyer groups</li>
                                    <li>YouTube influencers</li>
                                    <li>SEO traffic from land investors</li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="7">
                            <Accordion.Header>8. Will I get buyer leads directly?</Accordion.Header>
                            <Accordion.Body>
                                Yes. Your venture gets a dedicated page and leads are filtered
                                and shared with you. We can also manage first-level inquiries if
                                required.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="8">
                            <Accordion.Header>9. Can I list multiple ventures or locations?</Accordion.Header>
                            <Accordion.Body>
                                Absolutely. Each venture is reviewed separately and can be listed
                                after verification.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="9">
                            <Accordion.Header>10. What if my documents are incomplete?</Accordion.Header>
                            <Accordion.Body>
                                You can still submit your venture. Our team will guide you on
                                what’s needed to qualify and prepare for listing.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Container>
            </section>

            {/* Final CTA Section */}
            <section className="cta-section text-center">
                <Container>
                    <h2>
                        Ready to turn your land into a verified investment opportunity?
                    </h2>
                    <div className="d-flex justify-content-center gap-3 mt-3 flex-wrap">
                        <Button variant="warning">Submit My Venture</Button>
                        <Button variant="light">Talk to Our Experts</Button>
                    </div>
                </Container>
            </section>

            {/* Sticky Buttons for Mobile */}
            <div className="sticky-cta">
                <Button variant="warning" className="w-100 mb-2">
                    List Your Land
                </Button>
                <Button variant="success" className="w-100">
                    WhatsApp / Call Us
                </Button>
            </div>
        </>
    );
};

export default Landowners;
